module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00065-fs8.31b0a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00065-fs8.png
// module id = 218
// module chunks = 0